import { useNavigate } from '@tanstack/react-router';
import type { TenantMe } from '@studio/contracts';
import { supabase } from '@/lib/supabase';
import { Mast } from './sign-in-card';

/** Shown instead of the app when the organisation's trial has ended or the operator set it lapsed. */
export function AccessGate({ me }: { me: TenantMe }) {
  const navigate = useNavigate();
  const trial = me.access?.state === 'trial';
  const signOut = async (): Promise<void> => {
    await supabase().auth.signOut();
    await navigate({ to: '/sign-in' });
  };
  return (
    <main className="signin">
      <div className="card">
        <Mast />
        <div>
          <h1>{trial ? 'Trial ended' : 'Workspace paused'}</h1>
          <div className="lead">
            {trial && me.access?.trialEndsAt ? `${me.active?.orgName}'s trial ended on ${me.access.trialEndsAt}.` : `${me.active?.orgName} is not active.`}
            {' '}Get in touch to continue.
          </div>
        </div>
        <button type="button" className="btn quiet" onClick={() => void signOut()}>Sign out</button>
      </div>
    </main>
  );
}
